//
import Model from '@/models/Model'
import AChangeMaxCustomerCreditModel from '@/models/Actions/AChangeMaxCustomerCredit'

/**
 * This class describes a sl customer.
 *
 * @class      SlCustomer (name)
 */
export default class SlCustomer extends Model {

  /**
   * { item_description }
   */
  static appends = ['branch_offices']

  /**
   * { function_description }
   */
  block() {

    //
    this.blocked_sales = !this.blocked_sales

    //
    return this
  }

  get branch_offices_to_credit() {
    return this.getProperty('branch_offices', [])
  }

  /**
   * { function_description }
   * @return     {<type>}  { description_of_the_return_value }
   */
  changeMaxCustomerCredit() {
    return this.hasMany(AChangeMaxCustomerCreditModel)
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get flag_send_debt_email_str() {
    return this.flag_send_debt_email ? 'Activada' : 'Desactivada'
  }

  reset() {
    this.branch_offices = this.branch_offices ? this.branch_offices : []
    this.email_collection = this.email_collection ? this.email_collection : this.branch_offices.slice().pop().email
    return this
  }

  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'sl_customer'
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get nameRutCustomer() {
    return this.rut + ' ' + this.alias_name
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get blocked_sales_str() {
    return this.blocked_sales ? 'Bloqueado' : 'Desbloqueado'
  }

  mapCoreBusinessSII = ({ id }) => id

  /**
   * Prints a receivable.
   */
  printReceivable(customerBranchOfficesId) {
    /*console.log({ customerBranchOfficesId })*/
    return this
      .pdf('receivable_pdf', { 
        'filter[sl_customer_branch_offices_id]': customerBranchOfficesId
      })
      .then(this.showReceivable)
  }

  /**
   * { item_description }
   */
  showReceivable = this.showFile('CARTOLA DE MOVIMIENTOS', 'pdf')

  /**
   * Returns a block representation of the object.
   * @return {<type>}  Block representation of the object.
   */
  toBlock() {

    //
    this.sl_customer_id = this.id

    //
    return this
      .clean([
        'blocked_sales', 
        'sl_customer_id',
      ])
      .block()
  }

  /**
   * Returns a credit representation of the object.
   * @return {<type>}  Credit representation of the object.
   */
  toCredit() {
    return this
      .clean([
        'max_customer_credit_amount', 
      ])
  }

  /**
   * Returns an update representation of the object.
   * @return {<type>} Update representation of the object.
   */
  toUpdate() {

    //
    let clone = this.clone()

    ///
    clone.core_business = this.g_core_business_sii.map(this.mapCoreBusinessSII)

    //
    return clone.clean([
      'alias_name',
      'blocked_sales',
      'branch_offices',
      'business_name',
      'core_business',
      'email_collection',
      'pch_payment_condition_id',
      'discount',
      'flag_send_debt_email',
      //'main_g_core_business_sii_id',
      'id',
      'rut',
    ])
  }

  toggleSendDebtEmail() {

    //
    this.flag_send_debt_email = !this.flag_send_debt_email

    //
    return this
  }

  /**
   * { function_description }
   *
   * @param      {<type>}  amount  The amount
   * @return     {<type>}  { description_of_the_return_value }
   */
  updateCustomerMaxCreditAmount(amount) {
    let url = this.fullURL() + '/change_max_customer_credit'
    return this.$http.post(url, { max_customer_credit_amount: amount })
  }
}
